export const socialsData = {
  github: "https://github.com/sumansauravmay",
  // facebook: "https://www.facebook.com/",
  linkedIn: "https://www.linkedin.com/in/suman-saurav-06896b231/",
  // instagram: "https://www.instagram.com/",
  // codepen: "https://codepen.io/",
  // twitter: "https://twitter.com/AbdulQu32265251?t=FbJ6y-2tze1aYtlMpJfHXg&s=09",
  // reddit: "https://www.reddit.com/user/",
  // stackOverflow: "https://stackoverflow.com/users/",
};
